import { colours } from "../../_styleguide/_colours";
var ChartBarTrend = /** @class */ (function () {
    function ChartBarTrend(ctrlr, yParameter, colour) {
        this.ctrlr = ctrlr;
        this.yParameter = yParameter;
        this.colour = colour;
    }
    ChartBarTrend.prototype.draw = function (data) {
        var _this = this;
        this.bars = this.ctrlr.svg.layers.data.selectAll(".bar_" + this.yParameter)
            .data(data.slice)
            .join("rect")
            .attr("class", "bar_" + this.yParameter)
            .attr("fill", function (d) { return colours[_this.colour][1]; });
    };
    ChartBarTrend.prototype.redraw = function (data) {
        var _this = this;
        var self = this;
        var barWidth = this.ctrlr.dimensions.width / data.slice.length - 1;
        this.bars
            .attr("x", function (d, i) {
            return i > 0 ? self.ctrlr.scales.x.fn(d[self.ctrlr.parameters.x]) - barWidth : 0;
        })
            .attr("y", self.ctrlr.dimensions.height)
            .attr("height", 0)
            .attr("width", barWidth)
            .transition()
            .duration(500)
            .attr("y", function (d) { return (_this.ctrlr.config.extra.privacySensitive && d[self.yParameter] < 25) ? self.ctrlr.dimensions.height : self.ctrlr.scales.y.fn(d[self.yParameter]); })
            .attr("height", function (d) {
            var h = self.ctrlr.dimensions.height - self.ctrlr.scales.y.fn(d[self.yParameter]);
            if (h < 0) {
                //   console.log(d)
                h = 0;
            }
            return (_this.ctrlr.config.extra.privacySensitive && d[self.yParameter] < 25) ? 0 : h;
        });
    };
    return ChartBarTrend;
}());
export default ChartBarTrend;
